import ShareableLinkDrawer from './ShareableLinkDrawer.component';

export default ShareableLinkDrawer;